module.exports = __webpack_public_path__ + "static/media/at.a0e58653.svg";